import type { FaireProductEntity } from "../../entity_types/product";

export const p_kk2vutfmvf: FaireProductEntity = {
  token: "p_kk2vutfmvf",
  type: "product",
  name: "Cement Cloud Arch - White",
  brandToken: "b_vcqpcnsjcq",
  brandName: "The Minimalist Ceramist",
  imageUrl:
    "https://cdn.faire.com/fastly/401088257785abc9a50add6153726fe9c7249042c4fefd9bac571bdda22f43b6.jpeg",
  galleryImageUrls: [],
  priceDollars: 30,
  description:
    "The Cloud Arch is inspired by blossoming Spring and makes the perfect home for tiny treasures.\n\nThis is a gypsum cement reproduction of my original hand sculpted ceramic arch. The mold and cast were both handcrafted by me in my California home studio.\n\n• Approximately 7.5 x 7 inches\n• Weight: 2lbs\n• Stand on a table or shelf, or hang with a single nail or screw.\n\nPlease note: Due to the handmade nature of this product, slight variations in color and imperfections are to be expected and part of the handcrafted charm.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:25.216Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
